import React from 'react';
import { Line } from '@ant-design/plots';
import {getUsageCharts} from "../../api/console/index/Init";
import {Spin} from "antd";


class UsageChart extends React.Component {
    constructor(props){
        super(props);
        this.state={
            data: [],
            trendLoading: true,
            service: props.service
        };
        this.getUsageCharts = this.getUsageCharts.bind(this);
    }


    componentWillReceiveProps(props) {
        this.setState({
            data: [],
            trendLoading: true,
            service: props.service
        }, this.getUsageCharts);
    }


    getUsageCharts(){
        getUsageCharts(this.state.service)
            .then((response) => {
                this.setState({
                    data: response.data,
                    trendLoading: false,
                });
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            });
    }


    render() {

        const config = {
            data: this.state.data,
            title: {
                visible: true,
                text: '折线图',
            },
            xField: 'date',
            yField: 'count',
            height: 233,
            seriesField: 'type',
            yAxis: {
                label: {
                    // formatter: (v) => `${(v / 10e8).toFixed(1)} B`,
                },
            },
            xAxis: {
                type: 'time',
            },
            legend: {
                position: 'bottom',
            },
            smooth: true,
        };
        return (
            <Spin spinning={this.state.trendLoading}>
                <Line {...config} />
            </Spin>
        );
    }
}

export default UsageChart;
